import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';

import authSlice from './reducers/authSlice';
import propertyTypeSlice from './reducers/propertyTypeSlice';
import amenitySlice from './reducers/amenitySlice';
import usersSlice from './reducers/usersSlice';
import legalSlice from './reducers/legalSlice';
import faqsSlice from './reducers/faqsSlice';
import transactionsSlice from './reducers/transactionsSlice';
import fundingSourceSlice from './reducers/fundingSourceSlice';
import propertiesSlice from './reducers/propertiesSlice';
import reportsSlice from './reducers/reportsSlice';

const appReducer = combineReducers({
  userData: authSlice,
  propertyType: propertyTypeSlice,
  amenitySlice: amenitySlice,
  usersSlice: usersSlice,
  legal: legalSlice,
  faqs: faqsSlice,
  transactions: transactionsSlice,
  fundingSource: fundingSourceSlice,
  properties: propertiesSlice,
  reports: reportsSlice,
});

export const rootReducer = (state, action) => {
  if (action.type === `LOGOUT_USER`) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  devTools: process.env.NODE_ENV !== 'production',
});
